module.exports = __webpack_public_path__ + "media/cortina/motor-posicion-006459ec.png";